import { faEuroSign, faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { skillMarks } from "./skillMarks";
import { SkillMarks } from "./types";

const ICONS = { organization: faUsers, paid: faEuroSign };

/** De tekens van een skill: van de organisatie, kan geld kosten. */
export const SkillBadges = ({ skill }: { skill: SkillMarks & { updatedBy?: string } }) => (
  <>
    {skillMarks(skill).map((mark) => (
      <span
        key={mark.kind}
        title={mark.title}
        aria-label={mark.title}
        role="img"
        className={`ml-1 inline-flex text-[10px] ${
          mark.kind === "paid" ? "text-gold-brown" : "text-gray-400"
        }`}
      >
        <FontAwesomeIcon icon={ICONS[mark.kind]} />
      </span>
    ))}
  </>
);
